<div class="card-container" style="padding: 0;height:100%">
    <div class="title-head"
        style="border-bottom: 1px solid black;background-color: #4dc3a3;border-radius: 9px 9px 0 0 ;">
      <h1 class="main-tit" style="line-height: 2.2;margin:0;">PD Question Answer Data</h1>
    </div>
    <div style="min-height: 100%;" class="text-center"  *ngIf="!PDQuestionData">
        No Information Available!!
    </div>
    <div class="cnt-data" *ngIf="PDQuestionData" style="margin:10px">
        <div class="family">
            <!-- <div class="name-sub" style="margin-left: auto;margin-right: auto;left:0;right: 0;">
            <h1 style="margin-bottom: 2px;">Income Details</h1>
        </div> -->
            <div class="cont">
                <div *ngFor="let item of PDQuestionData">
                  <div class="cont-Card">
                    <div class="grd">
                      <div class="grd-item1">English</div>
                      <div class="grd-item">{{item.Question}}</div>

                    </div>
                    <div class="grd">
                      <div class="grd-item1">Hindi</div>
                      <div class="grd-item">{{item.Question_Hindi}}</div>

                    </div>
                    <div class="grd">
                      <div class="grd-item1">Answer</div>
                      <div class="grd-item" *ngIf="item.QuestionType!='Upload'">{{item.Answer}} </div>
                      <div class="grd-item" *ngIf="item.QuestionType=='Upload' && item.Answer!=''">
                        <a href="{{ docBaseUrl }}{{ item.Application_No }}/{{item.Answer}}" target="_blank">
                          {{item.Answer}}
                        </a>
                      </div>

                    </div>
                  </div>
                  </div>
            </div>
        </div>
    </div>

</div>
